<template>
  <Modal
    v-model="isSessionFeedbackModal"
    :classStr="'max-w-md'"
    :title="'Class Feedback'"
    v-on:input="handleClose"
  >
    <div class="flex flex-col space-y-8 mb-4">
      <div class="flex flex-col">
        <h6 class="text-lg font-medium leading-normal mt-0 mb-2 text-gray-dark">
          Were your expectations met?
        </h6>
        <div class="grid md:grid-cols-4 grid-cols-2 gap-4">
          <button
            type="button"
            class="h-8 px-2 text-xs transition-colors duration-150 ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-green-light hover:text-white capitalize"
            :class="
              d.id == rangeVal
                ? 'bg-green-light text-white'
                : 'text-green-light'
            "
            v-for="d in userReviewUserExpectations"
            :key="d.id"
            @click="handleRangeVal(d.id)"
          >
            {{ d.value }}
          </button>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <h6 class="text-lg font-medium leading-normal mt-0 mb-2 text-gray-dark">
        Rate your experience!
      </h6>
      <div class="flex">
        <div v-for="(d, i) in 5" :key="i">
          <button
            type="button"
            @click="handleStarClick(d)"
            class="focus:outline-none"
          >
            <Star v-if="i < rating" classStr="text-yellow-medium w-16 h-16" />
            <StarOutlined v-else :classStr="'text-yellow-medium w-16 h-16'" />
          </button>
        </div>
      </div>

      <p
        class="text-gray-dark text-md capitalize font-normal"
        v-if="ratingEditObj && ratingEditObj.expectation_id"
      >
        {{ getUserReviewRatingValue(ratingEditObj.expectation_id) }}
      </p>
      <p v-else>{{ getUserReviewRatingValue(rating) }}</p>
      <p class="text-gray-light text-xs">Rate your Class from 1-5 stars</p>
    </div>

    <div class="space-y-4">
      <p class="text-lg font-medium leading-normal mt-0 mb-2 text-gray-dark">
        Tell us what you liked
      </p>
      <div
        class="grid md:grid-cols-3 grid-cols-2 gap-4"
        v-if="userReviewRatingLikes && userReviewRatingLikes.length"
      >
        <button
          type="button"
          class="h-8 px-2 text-xs transition-colors duration-150 ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-green-light hover:text-white capitalize"
          :class="
            d.id == getLikesId(d.id)
              ? 'bg-green-light text-white'
              : 'text-green-light'
          "
          v-for="d in userReviewRatingLikes"
          :key="d.id"
          @click="handleRatingLikes(d)"
        >
          {{ d.value }}
        </button>
      </div>
      <div class="mb-4 text-gray-700">
        <label class="block mb-1 sr-only"> Description </label>
        <textarea
          class="w-full h-24 px-3 py-2 text-base text-gray-700 placeholder-gray-600 ring-1 ring-green-light rounded-lg focus:outline-none"
          placeholder="Share with us how the Class was and how it could be improved"
          v-model="$v.description.$model"
          :class="{ 'ring-red-700': $v.description.$error }"
        ></textarea>
        <div v-if="$v.description.$error">
          <span class="text-xs text-red-700" v-if="!$v.description.required">
            Description field is required
          </span>
        </div>
      </div>
      <div class="flex items-center space-x-4">
        <button
          type="button"
          class="w-full h-8 px-6 text-green-light transition-colors duration-150 ring-1 ring-green-light rounded-lg focus:outline-none hover:bg-green-light hover:text-white"
          @click.prevent="handleClose"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="w-full h-8 px-6 text-white transition-colors duration-150 bg-green-light rounded-lg focus:outline-none hover:bg-green-light"
          @click.prevent="handleSessionFeedbackSubmit"
        >
          {{ ratingEditObj && ratingEditObj.id ? "Update" : "Save" }}
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Star, StarOutlined } from "@/components/icons";
import { Modal } from "@/components/t-components";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SessionFeedbackModal",
  components: {
    Star,
    StarOutlined,
    Modal,
  },
  props: {
    isSessionFeedbackModal: {
      type: Boolean,
      default: false,
    },
    ratingEditObj: {
      type: Object,
    },
  },
  data() {
    return {
      isModalOpen: this.isSessionFeedbackModal,
      rangeVal: this.ratingEditObj && this.ratingEditObj.expectation_id,
      rating: this.ratingEditObj && this.ratingEditObj.star_rating,
      description: this.ratingEditObj && this.ratingEditObj.description,
      ratingImproveIds: [],
    };
  },
  validations: {
    description: {
      required,
    },
  },
  computed: {
    ...mapGetters(["userReviewUserExpectations", "userReviewRatingLikes"]),
  },
  methods: {
    ...mapActions([
      "getUserReviewUserExpectations",
      "postReviewRating",
      "putReviewRating",
      "getUserReviewRatingLikes",
    ]),

    handleClose() {
      this.isModalOpen = false;
      this.$emit("is-modal-open", false);
    },

    handleRangeVal(val) {
      this.rangeVal = val;
    },

    handleRatingLikes(obj) {
      var index = this.ratingImproveIds.findIndex((u) => u.id == obj.id);
      index === -1
        ? this.ratingImproveIds.push(obj)
        : this.ratingImproveIds.pop(obj);
    },

    handleSessionFeedbackSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        var data = {
          expectation_id: this.rangeVal,
          star_rating: this.rating,
          description: this.description,
          entity_id: this.$route.params.id,
          entity_type: this.SESSION,
        };
        var arr = [];
        for (var i = 0; i < this.ratingImproveIds.length; i++) {
          arr.push(this.ratingImproveIds[i].id);
        }
        data["rating_like_id"] = arr;
        if (this.ratingEditObj && this.ratingEditObj.id) {
          this.putReviewRating(data);
        } else {
          this.postReviewRating(data);
        }
        this.handleClose();
      }
    },

    getLikesId(val) {
      var arr = this.ratingImproveIds;
      var newObj = arr && arr.find((obj) => obj.id === val);
      return newObj && newObj.id;
    },

    handleStarClick(val) {
      this.rating = val;
    },
  },
  created() {
    this.getUserReviewUserExpectations();
    this.getUserReviewRatingLikes();
  },
};
</script>